import { Rarity } from '__generated__/globalTypes';
import { useSeriesNav } from 'hooks/commonGame/useSeriesNav';
import { isSupportedCardSet } from 'lib/cardSets';
import type { SupportedCardSet } from 'lib/cardSets';
import { isRarityStr } from 'lib/so5';

import { LIFECYCLE, useLifecycle } from '../useLifecycle';

export const usePinnedShardRarity = () => {
  const seriesNav = useSeriesNav();
  const { lifecycle, update: updateLifecycle } = useLifecycle();
  const [rarity, cardSet] =
    typeof lifecycle?.pinnedShardRarity === 'string'
      ? lifecycle.pinnedShardRarity.split(':')
      : [];

  // force pinned rarity to common winter if series nav is active
  const finalRarity = seriesNav ? Rarity.common : rarity;
  let finalCardSet = seriesNav ? 'winter' : cardSet;

  // default to common-base-set to support old pinned shard rarity with "common" as value
  if (finalRarity === Rarity.common && !finalCardSet) {
    finalCardSet = 'common-base-set';
  }

  return {
    pinnedShardRarity: isRarityStr(finalRarity) ? finalRarity : undefined,
    pinnedShardCardSet: isSupportedCardSet(finalCardSet)
      ? finalCardSet
      : undefined,
    updatePinnedShardRarity: (
      inputRarity: Rarity,
      inputCardSet: Nullable<SupportedCardSet>
    ) => {
      const value = `${inputRarity}${inputCardSet ? `:${inputCardSet}` : ''}`;
      updateLifecycle(
        LIFECYCLE.pinnedShardRarity,
        lifecycle?.[LIFECYCLE.pinnedShardRarity] === value ? false : value
      );
    },
  };
};
